import { render, staticRenderFns } from "./ImageUploadDropzone.vue?vue&type=template&id=99f85064&"
import script from "./ImageUploadDropzone.vue?vue&type=script&lang=js&"
export * from "./ImageUploadDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports